// extracted by mini-css-extract-plugin
export default {"default":"Alert__default--Kk2GN","outline":"Alert__outline--Hp7pt Alert__default--Kk2GN"};